import React, { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";

const EventLayout = () => {
  const [events, setEvents] = useState([]);
  const [provsOption, setProvsOption] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [cityOption, setCityOption] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [placesOptions, setPlacesOptions] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");

  const breadcrumb = {
    current_section: "Eventi",
    sections: [
      { name: "Eventi", route_name: null, params: [] },
      { name: "Elenco", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/ldc/ldcget`,
          fetchOptions
        );
        const result = await response.json();
        setPlacesOptions(
          convertIntoSelect2Options(result.return.ldc, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();
        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));
        setProvsOption(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchProvs();
    fetchLDCs();
  }, []);

  useEffect(() => {
    const fetchFilteredLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllLDC?provinceId=${
            selectedProvince ?? ""
          }&townId=${selectedCity ?? ""}`,
          fetchOptions
        );
        const result = await response.json();
        setPlacesOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchFilteredLDCs();
  }, [selectedProvince, selectedCity]);

  const handleProvinceChange = (event) => {
    setSelectedProvince(event?.value);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${event?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  const handleCityChange = (event) => {
    setSelectedCity(event?.value);
  };

  const handlePlaceChange = (event) => {
    setSelectedPlace(event?.value);
  };

  const handleSearch = () => {
    const fetchFilteredEvents = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllEvents?provinceId=${
            selectedProvince ?? ""
          }&townId=${selectedCity ?? ""}&ldcId=${
            selectedPlace ?? ""
          }&datainizio=${selectedStartDate ?? ""}&datafine=${
            selectedEndDate ?? ""
          }`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          alert("Nessun evento trovato con i filtri selezionati.");
          setEvents([]);
          return;
        }
        setEvents(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchFilteredEvents();
  };

  const handleDelete = async (id) => {
    const fetchOptions = getFetchOptions("application/json", [], "DELETE");
    fetch(
      `${axios.defaults.baseBFFUrl}/fe/deleteEvent?eventId=${id}`,
      fetchOptions
    ).then(() => {
      window.location = "/events";
    });
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      {/* Filters */}
      <div className="card custom-card">
        <div className="card-header">Filtri ricerca</div>
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-12 col-lg-2">
              <label htmlFor="province">Provincia</label>
              <Select
                options={provsOption}
                id="province"
                name="province"
                value={provsOption.filter(function (option) {
                  return option.value === selectedProvince;
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 col-lg-2">
              <label htmlFor="city">Comune</label>
              <Select
                options={cityOption}
                id="city"
                name="city"
                value={cityOption?.filter(function (option) {
                  return option.value === selectedCity;
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
              />
            </div>

            {/* Cultural Place Filter */}
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <label htmlFor="ldc">Luogo della cultura</label>
                <Select
                  options={placesOptions}
                  id="ldc"
                  name="ldc"
                  value={placesOptions?.filter(function (option) {
                    return option.value === selectedPlace;
                  })}
                  onChange={handlePlaceChange}
                  classNames={"form-control"}
                  placeholder="Scegli LDC..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            {/* Date Range Filters */}
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <label htmlFor="datainizio">Dal</label>
                <input
                  className="form-control"
                  id="datainizio"
                  name="datainizio"
                  type="date"
                  value={selectedStartDate}
                  onChange={(e) => {
                    setSelectedStartDate(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <label htmlFor="datafine">Al</label>
                <input
                  className="form-control"
                  id="datafine"
                  name="datafine"
                  type="date"
                  value={selectedEndDate}
                  onChange={(e) => {
                    setSelectedEndDate(e.target.value);
                  }}
                />
              </div>
            </div>

            {/* Search Button */}
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <button
                  id="btnSearch"
                  name="btnSearch"
                  className="searchButton btn btn-success w-100"
                  type="button"
                  onClick={handleSearch}
                >
                  &nbsp;Cerca
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Events List */}
      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Elenco Eventi</div>
            <div>
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    window.location.href = `/events/add`;
                  }}
                  type="button"
                  className="btn btn-primary text-uppercase"
                >
                  <i className="bi bi-plus-circle-fill"></i> Nuovo
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered custom-table">
              <thead>
                <tr>
                  <th width="10">ID</th>
                  <th width="10">Cover</th>
                  <th>Evento</th>
                  <th>Coordinate</th>
                  <th>Luogo</th>
                  <th>Periodo</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {events &&
                  events?.map((event) => (
                    <tr key={event.id}>
                      <td>{event.id}</td>
                      <td>
                        <img src={event.tokenimg} height="100" />
                      </td>
                      <td>{event.nomeevento}</td>
                      <td>
                        Latitudine: {event.latitude} <br />
                        Longitudine: {event.longitude}
                      </td>
                      <td>
                        {event.Town?.nome + " (" + event.Province.codice + ")"}
                      </td>
                      <td>
                        Dal {event.datainizio} alle {event.orainizio} <br />
                        Al {event.datafine} alle {event.orafine}
                      </td>
                      <td>
                        <div className="btn-list">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => {
                              window.location.href = `/events/edit/${event.id}`;
                            }}
                          >
                            <i className="align-middle bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Sei sicuro di voler eliminare questo evento?"
                                )
                              ) {
                                handleDelete(event.id);
                              }
                            }}
                          >
                            <i className="align-middle bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventLayout;
